export const sendContactInformation = async (data, email = 'ayudahutrit@gmail.com') => {
  const rawBody = JSON.stringify(data)

  const URL = `https://formsubmit.co/ajax/${email}`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: rawBody,
    })
    return response
  } catch (error) {
    console.log(error)
  }
}
